import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sorry-page',
  templateUrl: './sorry-page.component.html',
  styleUrls: ['./sorry-page.component.css'],
})
export class SorryPageComponent {
  //constructor() { }
  // ngOnInit(): void {
  // }
}
